export default {
  outList: [
    {
      light_point_1: [
        {
          title: '「檐平脊正」前脸造型',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '徽派建筑“檐平脊正” 的美学范式'
        },
      ],
      light_point_3: [
        {
          title: '百万同源 全铝合金车身',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '6系航空级铝合金车身+钢覆超强骨架',
          text2: '一体式压铸成型塔顶，减重30%，扭转刚度31812N·m/deg'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1: [
        {
          title: '15.6英寸中控大屏 + 9.2英寸仪表屏',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '15.6英寸 2560x1440 2.5K分辨率高清大屏'
        },
      ],
      light_point_2: [
        {
          title: '「四水归堂」内饰设计',
          type: 'image',
          video: '',
          image: 'lightPoint/4/3.jpg',
          text: '车内软包覆盖面积达2.036m²',
          text2: '仪表板软包面积0.561m²；3D Mesh清洁填充材料，无异味更环保',
        }
      ],
      light_point_3: [
        {
          title: '多维魔方大空间座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/4.jpg',
          text: '后排头部空间1022mm',
          text2: '后排全放倒，后备箱容积450L；放平后可达1238L',
        },
      ]
    }
  ],
  tab1: [
    {
      title: '百万同源 全铝合金车身',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '6系航空级铝合金车身+钢覆超强骨架',
      text2: '一体式压铸成型塔顶，减重30%，扭转刚度31812N·m/deg'
    },
    {
      title: '百万同源 铸铝H臂后悬',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '百万技术同源生产同线，FSD可变阻尼悬架；大幅减少侧倾和颠簸冲击，舒适性提升20%',
      text2: '驾驶更舒适：冲击缓冲提升40%，余震抑制提升50%；操控更灵动:簧下质量降低55%',
    },
    {
      title: '同级领先双电机智电四驱',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '同级领先的4.7s零百加速性能，双电机315kW峰值功率、505N·m峰值扭矩'
    },
  ],
  tab2: [
    {
      title: '大方设计美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '时尚东方 大方无隅'
    },
    {
      title: '大方宽体型格',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '最大21吋轮胎、高宽比0.93、轴长比0.612'
    },
    {
      title: '「檐平脊正」前脸造型',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '徽派建筑“檐平脊正” 的美学范式'
    },
    {
      title: '「方正立挺」车身侧型',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '轮高比2.35x，高视野一览无余'
    },
    {
      title: '超越同级的女性友好',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '柔光美颜化妆镜、舒云座椅、云台行车记录仪',
    },
    {
      title: '丰富可玩的生态产品',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '行李架真承重75Kg(同级领先)，30项改装配件：侧书包、后备箱小书包、侧爬梯、侧踏板、越野改装套件、物理按键、小背包妙语屏、锻造轮毂、AT胎...'
    },
  ],
  tab3: [
    {
      title: '真省-鲲鹏1.5T增程专用发动机',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '同级领先45.79%热效率，发电峰值功率100kw，行业领先3.71kWH/L油电转化效率'
    },
    {
      title: '真长-33.68kW·h增程专用高功率电池包',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '33.68kW·h增程专用高功率电池包',
      text2: '215km纯电续航；1200km+综合续航',
    },
    {
      title: '真静-图书馆级静谧',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '6大系统，11项NVH技术升级，增程器介入舱内噪声≤39dB',
    },
    {
      title: '超高户外通过性',
      type: 'image',
      video: '',
      image: 'lightPoint/3/4.jpg',
      text: '225mm离地间隙，625mm涉水深度，接近角22°/离去角30°，爬坡度100%',
    },
    {
      title: '8+X全路况模式',
      type: 'image',
      video: '',
      image: 'lightPoint/3/5.jpg',
      text: '4种日常驾驶模式+X全路况模式，5种极限模式（圆规掉头、坦克掉头、低速蠕行、柔性下坡、越野单踏板），越野智控踏板模式'
    },
    {
      title: '坦克掉头+极限掉头',
      type: 'image',
      video: '',
      image: 'lightPoint/3/6.jpg',
      text: '城野可用，转弯半径由5.7m至高缩减至3m'
    },
    {
      title: '猎鹰500驾驶辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/3/7.jpg',
      text: '算法更先进：一段式端到端算法，不依赖高精地图；场景更丰富：高速领航，泊车场景300+(遥控泊车、循迹倒车、跨层记忆泊车等)'
    }

  ],
  tab4: [
    {
      title: '车规级8155芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '105K DMIPS超高算力，四音区独立识别',
      text2: '30+微信小程序、聊天、唱K、打游戏，满足各种娱乐需求',
    },
    {
      title: '15.6英寸中控大屏 + 9.2英寸仪表屏',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '15.6英寸 2560x1440 2.5K分辨率高清大屏'
    },
    {
      title: '「四水归堂」内饰设计',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '车内软包覆盖面积达2.036m²',
      text2: '仪表板软包面积0.561m²；3D Mesh清洁填充材料，无异味更环保',
    },
    {
      title: '多维魔方大空间座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/4.jpg',
      text: '后排头部空间1022mm',
      text2: '后排全放倒，后备箱容积450L；放平后可达1238L',
    },
  ],
  tab5: [
    {
      title: '三明治电池防护结构',
      type: 'image',
      video: '',
      image: 'lightPoint/5/1.png',
      text: '105K 铝合金下壳体，采用航空级6系铝合金有效抵御碰撞',
    },
    {
      title: '20+项主动安全功能',
      type: 'image',
      video: '',
      image: 'lightPoint/5/2.jpg',
      text: 'AEB自动紧急制动（120km/h）、LKA车道保持辅助、LDW车道偏离预警、540全景影像、FCW前碰撞预警系统、DAI前车驶离提醒、透明底盘',
    },

    {
      title: '标配被动安全',
      type: 'image',
      video: '',
      image: 'lightPoint/5/3.jpg',
      text: '电子儿童锁+电释放门、标配6气囊、60%蜂窝状内纵梁结构侧碰防护、60%航空级6系铝合金溃缩能力',
    },
  ]
}
